import { createQueryKey, getFetchedDataPayload } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../store';
export const getFilmAvailability = (filmId, siteId) => {
    const queryKey = createQueryKey({ filmId, siteId });
    return getFetchedDataPayload(browsingDomainStore.data.filmAvailabilitiesByQuery[queryKey]);
};
//# sourceMappingURL=get-film-availability.js.map